import { ChangeEvent, useCallback, useState } from 'react'

import { PromptRouter3Custom } from 'app/components/common/Prompt'
import { ContentGroup } from 'app/common/templates-next/page-template'
import { BankDetailsFormControls, clearMask } from 'app/components/common/bankDetails'
import usePopup from 'app/common/hooks/usePopup'
import { useBankDetailsBikCheking } from 'app/dataProviders/account/bankDetails/hooks/useBankDetailsBikCheking'

import HeaderWithSubmit from './HeaderWithSubmit'
import styles from './BankDetails.scss'


const formID = 'bankDetailsInfo'

type Props = {
  route: any
  className?: string
}

export function BankDetails({ route, className }: Props) {
  const [modified, setModified] = useState(false)

  const {
    bikRequestAndValidate,
    updateBankDetails,
    bankDetailsProps,
    bankDetailsLoading,
    resetBankDetails,
    bikError,
    formStateHandler,
    corrAccountLength,
    bikLength,
  } = useBankDetailsBikCheking({ onModified: setModified })

  const popup = usePopup()

  const saveHandler = useCallback(async (e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault()
    const { id } = e.target
    if (id !== formID) return

    const bikWithoutMask = clearMask(bankDetailsProps.bik)
    const checkingAccWithoutMask = clearMask(bankDetailsProps.checkingAccount)

    if (bikWithoutMask.length === bikLength
      && checkingAccWithoutMask.length === corrAccountLength
      && bankDetailsProps.bankTitle.length !== 0
      && bankDetailsProps.corrAccount.length !== 0
    ) {
      const res = await updateBankDetails(bankDetailsProps)
      if (res) {
        popup('Банковские реквизиты успешно сохранены')
        setModified(false)
      }
    }
  }, [bankDetailsProps, popup, updateBankDetails, corrAccountLength, bikLength])

  return (
    <div className={className}>
      <ContentGroup>
        <form onSubmit={saveHandler} id={formID}>
          <HeaderWithSubmit
            title="Банковские реквизиты"
            showFormControls={modified}
            onClickCancel={resetBankDetails}
          />
          <BankDetailsFormControls
            className={styles.form}
            bankDetailsProps={bankDetailsProps}
            loading={bankDetailsLoading}
            onChangeValue={formStateHandler}
            onBikRequestAndValidate={bikRequestAndValidate}
            bikErrorText={bikError}
            corrAccountLength={corrAccountLength}
          />
        </form>
      </ContentGroup>
      <PromptRouter3Custom
        route={route}
        when={modified}
        message="Вы не сохранили изменения, перейти в любом случае?"
      />
    </div>
  )
}
